
import { Component, Mixins, Emit } from "vue-property-decorator";
import { fetchBanners } from "@/services/userService";
import store from "@/store";
import Home from "@/mixins/Home";
import HomeMainVisual from "@/components/home/HomeMainVisual/HomeMainVisual.vue";
import HomeSlider from "@/components/home/HomeSlider/HomeSlider.vue";
import NaviSerchnavi from "@/components/navi/NaviSerchnavi/NaviSerchnavi.vue";
import HomeFavoritelist from "@/components/home/HomeFavoritelist/HomeFavoritelist.vue";
import HomeCampaignlist from "@/components/home/HomeCampaignlist/HomeCampaignlist.vue";
import HomeNewslist from "@/components/home/HomeNewslist/HomeNewslist.vue";
import HomePickuplist from "@/components/home/HomePickuplist/HomePickuplist.vue";
import HomeHistory from "@/components/home/HomeHistory/HomeHistory.vue";
import HomeSns from "@/components/home/HomeSNS/HomeSNS.vue";
import HomeSpecialoffer from "@/components/home/HomeSpecialoffer/HomeSpecialoffer.vue";
import HomeAlignment from "@/components/home/HomeAlignment/HomeAlignment.vue";
import ButtonTodayLowestPrice from "@/components/button/ButtonTodayLowestPrice.vue";
import HomeAlignmentShareholder from "@/components/home/HomeAlignment/HomeAlignmentShareholder.vue";
import ButtonToday from "@/mixins/ButtonToday";
import ButtonLineMini from "@/components/button/ButtonLineMini.vue";
import ButtonRewardsClub from "@/components/button/ButtonRewardsClub.vue";
import $ from "jquery";
@Component({
  components: {
    HomeMainVisual,
    HomeSlider,
    NaviSerchnavi,
    HomeFavoritelist,
    HomeCampaignlist,
    HomeNewslist,
    HomePickuplist,
    HomeHistory,
    HomeSns,
    HomeSpecialoffer,
    HomeAlignment,
    HomeAlignmentShareholder,
    ButtonTodayLowestPrice,
    ButtonLineMini,
    ButtonRewardsClub,
  },
})
export default class HomeJa extends Mixins(Home, ButtonToday) {
  private firstBanner: boolean = false;
  private popupBanner: null | BannerData = null;
  private alignmentBlackList: string = process.env.VUE_APP_ALIGNMENT_BLACK_LIST || "";
  get account(): string {
    return store.getters["auth/account"];
  }
  get newsCancelUrl(): string {
    return "/pages/mghcp-note";
    // return process.env.VUE_APP_NEWS_CANCEL_URL;
  }
  get mghrecUrl(): string {
    return "/pages/mghrc2025-note";
    // return process.env.VUE_APP_MGHRWC_URL;
  }
  get showAlignment(): boolean {
    if (!store.getters["auth/group"]) {
      return false;
    }
    const blackList = this.alignmentBlackList.split(",");
    return !blackList.includes(store.getters["auth/group"]);
  }

  @Emit()
  private clickTodayBanner() {
    window.gtag("event", "CrntFunction", {
      event_category: "todayHotel",
      event_label: "todayHotel02",
    });
  }

  get token(): boolean {
    return store.getters["auth/token"];
  }

  get isShareholder(): boolean {
    return store.getters["auth/isShareholder"];
  }

  private async getPopupBanner() {
    const res = await fetchBanners({ cat: "popup-banner" });
    if (res.length > 0) {
      const max = res.length;
      const min = 0;
      const ran = Math.floor(Math.random() * (max - min) + min);
      this.popupBanner = res[ran];
    }
    this.$nextTick(() => {
      $(".topBanner .close, .topBanner .bg").on("click", function (ev) {
        ev.preventDefault();
        $(".topBanner").fadeOut(function () {
          $(".topBanner").remove();
        });
      });
    });

    sessionStorage["first-banner"] = "1";
  }

  private created() {
    if (!sessionStorage.getItem("first-banner")) {
      this.getPopupBanner();
    }
  }
  private async getSlider() {
    const refs: any = this.$refs;
    if (refs.slider) {
      await refs.slider.getEntries();
    }
    this.loaded = true;
    store.commit("loaded", true);
  }
  private mounted() {
    const refs: any = this.$refs;
    const arr = [];
    if (refs.slider) {
      this.getSlider();
      // arr.push(refs.slider.getEntries());
    }
    if (refs.favoritelist) {
      arr.push(refs.favoritelist.getEntries());
    }
    if (refs.campaignlist) {
      arr.push(refs.campaignlist.getEntries());
    }
    if (refs.newslist) {
      arr.push(refs.newslist.getEntries());
    }
    if (refs.pickuplist) {
      arr.push(refs.pickuplist.getEntries());
    }
    if (refs.historylist) {
      arr.push(refs.historylist.getEntries());
    }
    if (refs.specialoffer) {
      arr.push(refs.specialoffer.getEntries());
    }
    Promise.all(arr);
  }
}
